import React from 'react';

const PlusIcon = () => (
    <svg className="icon nui-betbook-profile-plus-icon" viewBox="0 0 16 16">
        <path
            d="M8 0c.414 0 .75.336.75.75v6.5h6.5c.414 0 .75.336.75.75s-.336.75-.75.75h-6.5v6.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-6.5H.75C.336 8.75 0 8.414 0 8s.336-.75.75-.75h6.5V.75C7.25.336 7.586 0 8 0z"
            transform="translate(-113 -624) translate(0 24) translate(30 590) translate(83 8) translate(0 2)"
        />
    </svg>
);

export default PlusIcon;
